(function () {
    'use strict';

    angular
        .module('news')
        .controller('NewsCreateController', NewsCreateController);
    NewsCreateController.$inject = ['$uibModal', 'NewsService', '$scope', 'FileUploader', '$sce', 'toastr', 'API_BASE'];

    function NewsCreateController($uibModal, NewsService, $scope, FileUploader, $sce, toastr, API_BASE) {
        var vm = this;
        vm.flag = false;
        vm.changeMediaType = changeMediaType;
        vm.mediaTypeSelected = [];
        vm.mediaTypeImage = false;
        vm.mediaTypeVideo = false;
        vm.hasFileToUpload = false;
        vm.title = '';
        vm.newsText = '';
        vm.newsStatus = 'draft';
        vm.mediaImage = [];
        vm.mediaVideo = '';
        //vm.activate                 = activate;
        vm.store = store;
        vm.uploadFile = uploadFile;
        vm.formValid = false;
        //vm.changeImage              = changeImage(files);
        vm.filePath = false;
        vm.mediaTypes = [{
                value: 'image',
                name: 'Image'
            },
            {
                value: 'video',
                name: 'Video'
            }
        ];

        vm.options = {
            height: 300,
            focus: true,
            airMode: false,
            styleTags: ['p', 'h1'],
            toolbar: [
                ['edit', ['undo', 'redo']],
                ['headline', ['style']],
                ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough']], //, 'clear'
                //['fontface', ['fontname']],
                //['textsize', ['fontsize']],
                //['fontclr', ['color']],
                //['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                //['height', ['height']],
                //['table', ['table']],
                //['insert', ['link','picture','video','hr']],
                // ['insert', ['link']],
                //['view', ['fullscreen', 'codeview']],
                ['view', ['fullscreen']]
                //['help', ['help']]
            ]
        };

        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        }

        function changeMediaType() {
            if (vm.mediaTypeSelected.value === 'image') {
                vm.mediaTypeImage = true;
                vm.mediaTypeVideo = false;
            }

            if (vm.mediaTypeSelected.value === 'video') {
                vm.mediaTypeImage = false;
                vm.mediaTypeVideo = true;
            }
        }

        activate();

        function activate() {}

        function store(publish = false) {
            vm.newsStatus = (publish === true) ? 'published' : 'draft';
            save();
        }

        function save() {
            if (vm.mediaVideo && vm.mediaVideo !== '') {
                vm.validVideoUrl = parseVideo(vm.mediaVideo);
                if (!vm.validVideoUrl) {
                    toastr.error("The video url is invalid.");
                    return false;
                }
            }

            vm.fields = {
                media_type: vm.mediaTypeSelected.value,
                file: vm.mediaImage,
                title: vm.title,
                text: vm.newsText,
                status: vm.newsStatus,
                video: vm.mediaVideo,
                image: vm.mediaImage
            };

            NewsService.storeNews(vm.fields).then(function (response) {
                if (response.status) {
                    vm.imgPath = response.url;
                    toastr.success(response.message);
                } else {
                    toastr.error(response.message);
                }
            }).catch(function (err) {});
        }

        function parseVideo(url) {
            // - Supported YouTube URL formats:
            //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
            //   - http://youtu.be/My2FRPA3Gf8
            //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
            // - Supported Vimeo URL formats:
            //   - http://vimeo.com/25451551
            //   - http://player.vimeo.com/video/25451551
            // - Also supports relative URLs:
            //   - //player.vimeo.com/video/25451551

            url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
            if (RegExp.$3.indexOf('youtu') > -1) {
                return "youtube";
            }
            if (RegExp.$3.indexOf('vimeo') > -1) {
                return 'vimeo';
            } else {
                toastr.error("The video url is not valid");
                return false;
            }
        }

        function uploadFile(event) {
            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function (event) {
                $scope.$apply(function () {
                    vm.mediaImage = event.target.result;
                });
            };
            reader.readAsDataURL(file);
        }
    }
})();